import * as Api from '@ViewModels';

export const ALL_PROVIDERS = 'all';

export type ProviderFilter = Api.IntegrationProvider | typeof ALL_PROVIDERS;

export function matchesSearch(search: string, accountId: string, companyName: string | null): boolean {
	if (!search) {
		return true;
	}
	return accountId.toLowerCase().includes(search) || (companyName ?? '').toLowerCase().includes(search);
}

export function matchesProvider(filter: ProviderFilter, provider: Api.IntegrationProvider): boolean {
	return filter === ALL_PROVIDERS || filter === provider;
}
